//imports
import React, { useState, useRef } from "react";
import Barcode from "react-barcode";
import {
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Paper,
  Toolbar,
  Snackbar,
  Alert,
  Slide,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import { externalgetApi, externalpostApi } from "../../services/external/externalApis";
import { COMMON_API_02, SETTINGS_API_23 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { useEffect } from "react";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
const BarcodeGenerator = ({ selectedMenuName, selectedMenucode, isEdit }) => {
  //hooks
  const [barcodeValue, setBarcodeValue] = useState("");
  const [autoGenerate, setAutoGenerate] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};
  const [inputError, setInputError] = useState("");
  const barcodeRef = useRef(null);
    const [data, setData] = useState([]);
  //functions
  const handleCheckboxChange = (event) => {
    setAutoGenerate(event.target.checked);
    if (event.target.checked) {
      generateBarcode();
    }
  };

  const handleInputChange = (event) => {
    setBarcodeValue(event.target.value);
  };

  const generateBarcode = () => {
    const randomValue = Math.floor(Math.random() * 1000000000000).toString();
    setBarcodeValue(randomValue);
  };

  const getBarcodeImage = () => {
    if (barcodeRef.current) {
      const canvas = barcodeRef.current.querySelector("canvas");
      return canvas ? canvas.toDataURL("image/png") : "";
    }
    return "";
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = () => {
    setOpenErrorSnackbar(false);
  };

  const checkDuplicateBarcode = () => {
  const existingItems = Array.isArray(data) ? data : [data];

  const duplicate = existingItems.find(
    (item) =>
      String(item.BARCODE || "").trim() === barcodeValue.trim() &&
      String(item.MENUCODE) !== String(selectedMenucode)
  );

  return Boolean(duplicate);
};
  //postapi
const handleConfirmClick = async () => {
  // Validate barcode format
  if (!/^\d{3,13}$/.test(barcodeValue)) {
    setSnackbarMessage(
      barcodeValue.length < 3
        ? "Barcode must contain at least 3 digits."
        : "Barcode must contain only numbers and cannot exceed 13 digits."
    );
    setOpenErrorSnackbar(true);
    return;
  }

  // Check duplicate barcode
  if (checkDuplicateBarcode()) {
    setSnackbarMessage(
      "This barcode is already assigned to another item."
    );
    setOpenErrorSnackbar(true);
    return;
  }

  const encodedBarcodeValue = btoa(barcodeValue);

  const payload = {
    COMPCODE,
    LOCCODE,
    RESTCODE,
    MENUCODE: String(selectedMenucode),
    BARCODE: barcodeValue,
    BARCODEIMAGE: encodedBarcodeValue,
  };

  try {
    await externalpostApi(SETTINGS_API_23, payload);

    setSnackbarMessage(
      isEdit
        ? "Barcode Updated Successfully!"
        : "Barcode Created Successfully!"
    );
    setOpenSnackbar(true);
  } catch (error) {
    console.error("Error:", error);
    setSnackbarMessage("Failed to generate barcode.");
    setOpenErrorSnackbar(true);
  }
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const today = new Date();
        const formattedToday = `${today.getFullYear()}-${String(
          today.getMonth() + 1
        ).padStart(2, "0")}-${String(today.getDate()).padStart(
          2,
          "0"
        )} 23:59:59`;
        const result = await externalgetApi(COMMON_API_02, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          TODAY: formattedToday,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
       console.log("Fetched Data:", result); // Log the fetched data for debugging
     // Log the fetched data for debugging
      } catch (err) {
       
      }
    };

    fetchData();
  }, [COMPCODE, LOCCODE, RESTCODE]);

  useEffect(() => {
  if (!data || !selectedMenucode) {
    setBarcodeValue("");
    return;
  }

  const existingItems = Array.isArray(data) ? data : [data];

  const selectedItem = existingItems.find(
    (item) =>
      String(item.MENUCODE) === String(selectedMenucode)
  );

  if (selectedItem && selectedItem.BARCODE) {
    setBarcodeValue(String(selectedItem.BARCODE));
  } else {
    setBarcodeValue("");
  }

  setInputError("");
  setAutoGenerate(false);
}, [selectedMenucode, data]);

  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        p: 2,
        borderRadius: "4px",
        boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
      }}
    >
      <Toolbar
        sx={{
          width: "100%",
          background: theme.palette.background.paper,
          marginTop: {
            xs: "170px",
            md: "5px",
          },
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}
      >
        <Typography
          sx={{
            color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Generate Barcode
        </Typography>
      </Toolbar>
      <Paper elevation={5} style={{ padding: "2rem" }}>
<Tooltip title={`Item Name: ${selectedMenuName}`} arrow placement="top">
  <Typography
    variant="h4"
    gutterBottom
    sx={{
      color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818",
      fontSize: "18px",
      fontWeight: 600,
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      minWidth: 0,
      cursor: "default",
    }}
  >
    Item Name: {selectedMenuName}
  </Typography>
</Tooltip>
     

<TextField
  fullWidth
  variant="outlined"
  value={barcodeValue}
  onChange={(event) => {
    const value = event.target.value;

    if (!/^\d*$/.test(value)) {
      setInputError("Only numbers are allowed.");
      return;
    }

    if (value.length > 13) {
      setInputError("Barcode cannot exceed 13 digits.");
      return;
    }

    setBarcodeValue(value);
    setInputError("");
  }}
  error={Boolean(inputError)}
  helperText={inputError}
  inputProps={{
    inputMode: "numeric",
  }}
  InputProps={{
    style: { textAlign: "center", fontSize: "1.5rem" },
  }}
/>
      <Paper
  elevation={0}
  ref={barcodeRef}
  sx={{
    p: 2,
    mt: 5,
    minHeight: 160,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px dashed ${theme.palette.input_field.stroke}`,
    borderRadius: 2,
    backgroundColor: theme.palette.background.default,
    boxSizing: "border-box",
  }}
>
  {barcodeValue ? (
    <Barcode value={barcodeValue} />
  ) : (
    <Typography
      variant="body2"
      color="text.secondary"
    >
      Barcode preview will appear here
    </Typography>
  )}
</Paper>
      
   <Box
  display="flex"
  gap={2}
  mt={11}
  justifyContent="flex-end"
  alignItems="center"
>
  {/* <Button
    variant="outlined"
    sx={styles.AI_button1}
    onClick={() => {
      setBarcodeValue("");
      setAutoGenerate(false);
      setInputError(false);
    }}
  >
    Clear
  </Button> */}

  <Button
    variant="contained"
    color="primary"
    onClick={handleConfirmClick}
    sx={{
      textTransform: "capitalize",
      letterSpacing: "1px",
    }}
  >
    Confirm
  </Button>
</Box>
      </Paper>

      {/* Success Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={openErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage || "Please fill out all fields before submitting."}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BarcodeGenerator;
